import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { OktaAuthService } from '@okta/okta-angular';
import { MiscAdapter } from 'src/adapters/misc-adapter';
import { UserInfo } from 'src/app/data/classes/user-info'

@Injectable({
    providedIn: 'root'
})
export class UserService {

    private userObject: UserInfo;

    // private promise: Promise<UserInfo>;

    constructor(private http: HttpClient,
        private oktaAuth: OktaAuthService,
        private miscAdapter: MiscAdapter) { }

    public getUser(): Promise<UserInfo> {
        if (this.userObject) {
            // if we have userObject defined, we do not need the promise variable
            return Promise.resolve(this.userObject);
        } else {
            return this.oktaAuth.getAccessToken().then(token => {
                const userClaims = JSON.parse(atob(token.split(".")[1]));
                this.userObject = new UserInfo(userClaims);
                return this.userObject;
            });
        }
    }

    public getUserWithDetails(): Promise<UserInfo> {
        return this.getUser()
            .then(user => {
                if (user.details) {
                    return user;
                }

                return this.miscAdapter.getUserDetails()
                    .then(details => {
                        user.details = details;
                        this.userObject.details = details;
                        return user;
                    }).catch(e => {
                        console.error(e);
                        return user;
                    });
            });
    }
}
